import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cap',
})
export class CapPipe implements PipeTransform {
  transform(value: any): any {
    if (value === null || value === undefined) {
      return value;
    }
    let modifiedInput = value.toString().replace(/,/g, '');
    modifiedInput = parseInt(modifiedInput, 10);
    if (isNaN(modifiedInput) || modifiedInput < 0) {
      return 0;
    } else if (modifiedInput > 9999) {
      return '-';
    } else {
      return value;
    }
  }
}
